import {Component} from '@angular/core';
@Component({
  selector: 'app-inproguess',
  templateUrl: './inproguess.component.html',
  styleUrls: ['./inproguess.component.scss']
})
export class InproguessComponent {}
